import React from "react";

// Shown instead of the plain inline error text when a request failed because
// the backend couldn't be reached at all (network error) or returned a
// 500/502/503/504 (api.js's response interceptor flags both cases via
// `error.isServerUnavailable` and already strips any raw Laravel/SQL detail
// out of the message before it gets here).
export default function ServerUnavailableNotice({ onRetry, retrying = false }) {
  return (
    <div className="rounded-xl border border-red-200 bg-red-50 p-4 mb-4 text-center">
      <p className="text-red-700 font-semibold text-lg mb-1">Server Unavailable</p>
      <p className="text-red-600 text-sm mb-3">
        We're unable to connect to the server right now. Please try again later.
      </p>
      {onRetry && (
        <button
          type="button"
          onClick={onRetry}
          disabled={retrying}
          className="text-sm font-semibold text-red-700 border border-red-300 rounded-lg px-4 py-2 hover:bg-red-100 disabled:opacity-50 disabled:cursor-not-allowed transition"
        >
          {retrying ? "Retrying…" : "Retry"}
        </button>
      )}
    </div>
  );
}
